import { IconProps } from "../../utils/global-types/global-types";

const DraftIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M14.374 5.791H12.02c-.724 0-1.314-.59-1.314-1.314V2.124c.14.058.274.151.386.262l3.019 3.02c.11.11.198.245.263.385"
      ></path>
      <path
        fill="currentColor"
        d="M12.02 6.667a2.193 2.193 0 0 1-2.19-2.19V2.001H4.506a1.32 1.32 0 0 0-1.32 1.32v11.252c0 .728.59 1.318 1.318 1.318h8.674c.728 0 1.318-.59 1.318-1.318V6.667zm-6.028 1.16h2.27a.526.526 0 0 1 0 1.05h-2.27a.526.526 0 0 1 0-1.05m4.502 6.03H5.992a.526.526 0 0 1 0-1.051h4.502a.526.526 0 0 1 0 1.05m1.197-2.49h-5.7a.526.526 0 0 1 0-1.05h5.7a.526.526 0 1 1 0 1.05"
      ></path>
    </svg>
  );
};

export default DraftIcon;
